// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#navbar-portal-title[data-v-4c0adab6]{font-size:1.2em!important;margin-left:1em!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
